import { useTranslation } from 'react-i18next';

import DateInput from 'components/field/DateInput';
import EnumSelect from 'components/field/EnumSelect';
import ScoreCard from 'components/field/ScoreCard';
import Radio from 'components/global/Radio';
import Typography from 'components/global/Typography';
import DynamicListFloatInput from 'components/list/FilterInputs/DynamicListFloatInput';
import DynamicListNumberInput from 'components/list/FilterInputs/DynamicListNumberInput';
import DynamicListStringInput from 'components/list/FilterInputs/DynamicListStringInput';

import TableFilterTypes from '../Filters/TableFilterTypes';
import * as S from './TableHeaderFilter.styled';

const TableHeaderFilter = ({ column }) => {
	const { t } = useTranslation();
	const data = Array.from(column.getFacetedUniqueValues().keys()).filter(
		(val) => val !== null && val !== undefined && val !== ''
	);
	const value = column.getFilterValue();

	switch (column.columnDef.filterFn) {
		case TableFilterTypes.string:
			return (
				<DynamicListStringInput
					autoFocus={false}
					className="header-filter"
					value={value}
					setValue={column.setFilterValue}
				/>
			);

		case TableFilterTypes.number:
			return (
				<DynamicListNumberInput
					autoFocus={false}
					className="header-filter"
					value={value}
					setValue={column.setFilterValue}
				/>
			);

		case TableFilterTypes.float:
			return (
				<DynamicListFloatInput
					autoFocus={false}
					className="header-filter"
					value={
						value
							? {
									min: value[0],
									max: value[1]
								}
							: null
					}
					setValue={(value) => {
						column.setFilterValue(value ? [value.min, value.max] : null);
					}}
				/>
			);

		case TableFilterTypes.date:
			return <DateInput rangeMode className="header-filter" value={value} setValue={column.setFilterValue} />;

		case TableFilterTypes.selection:
			return (
				<EnumSelect
					className="header-filter"
					placeholder="select"
					data={data}
					value={value ?? null}
					setValue={column.setFilterValue}
					fixedContainerWidth={false}
				/>
			);

		case TableFilterTypes.multiSelection:
			return (
				<EnumSelect
					className="header-filter"
					placeholder="select"
					data={data}
					value={value ?? null}
					setValue={column.setFilterValue}
					fixedContainerWidth={false}
					multipleSelection
				/>
			);

		case TableFilterTypes.enum:
			return (
				<EnumSelect
					className="header-filter"
					placeholder="select"
					data={data}
					enumName={column.columnDef.enumName}
					value={value ?? null}
					setValue={column.setFilterValue}
					fixedContainerWidth={false}
				/>
			);

		case TableFilterTypes.enumMulti:
			return (
				<EnumSelect
					className="header-filter"
					placeholder="select"
					data={data}
					enumName={column.columnDef.enumName}
					value={value ?? null}
					setValue={column.setFilterValue}
					fixedContainerWidth={false}
					multipleSelection
				/>
			);

		case TableFilterTypes.rating:
			return (
				<EnumSelect
					className="header-filter"
					placeholder="select"
					data={[5, 4, 3, 2]}
					value={value ?? null}
					setValue={column.setFilterValue}
					fixedContainerWidth={false}
					renderOption={(value) => {
						return (
							<S.RatingFilterWrapper>
								<Radio />
								<ScoreCard value={value} showText={false} disabled size="small" />
								<Typography fontWeight="500">
									{value === 5
										? value.toFixed(1)
										: t('ratingFilter.valueAndUp', { value: value.toFixed(1) })}
								</Typography>
							</S.RatingFilterWrapper>
						);
					}}
					renderSelectionValue={(value) => {
						return (
							<S.RatingFilterWrapper>
								<ScoreCard value={value} showText={false} disabled size="small" />
							</S.RatingFilterWrapper>
						);
					}}
				/>
			);

		default:
			throw new Error('Unknown filter type!');
	}
};

export default TableHeaderFilter;
